module.exports = __webpack_public_path__ + "static/media/finance_deal.adf87f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/finance_deal.png
// module id = 249
// module chunks = 0